// NOTE! Changing these will not change behavior for components that use css + media queries.
// This will however change behavior for react components that actually make use of these breakpoints.
export const SCREEN_BREAKPOINTS = {
    xs: 0,        // base
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280
};
